<template>
<div class="fit-modal" >
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content" >
    <div v-if="! successModal">
      <span class="modal__result-details">
      <span class="result-title">{{ $t('SURE_TO_UNSUBSCRIBE') }} </span>

    </span>
      <div class="d-flex justify-content-around align-items-center">
        <argon-button full-width
                      color="dark"
                      variant="gradient"
                      class="my-4 me-2"
                      @click="modalClose"
                      style="background: #3EAAFF; color: #FFFFFF;">
          {{ $t('CANCEL') }}
        </argon-button>
        <argon-button color="dark" full-width
                      variant="gradient"
                      class="my-4"
                      @click="cancelPurchaseBundle"
                      style="background: #3EAAFF; color: #FFFFFF">
          {{ $t('YES') }}
        </argon-button>
      </div>
    </div>
    <div class="success-msg-modal d-flex flex-column justify-content-center align-items-center" v-else>
      <div class="success-msg-title"
           :class="{'text-danger': ! successStatus}"
           style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">
        {{ unsubscribeStatus }}
      </div>
      <div class="success-msg-details"
           style="font-size: 13px; font-weight: 700;">
        {{ unsubscribeMsg }}
      </div>
      <argon-button color="dark" full-width
                    variant="gradient"
                    class="my-4"
                    @click="modalClose"
                    style="background: #3EAAFF; color: #FFFFFF">
        {{ $t('OKAY') }}
      </argon-button>
    </div>
  </vue-final-modal>

</div>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';
import ArgonButton from "@/components/ArgonButton.vue";
import {sendRequest} from "@/http/axios.method";

export default {
  name: "UnsubscribeModal",
  props: ['modalShow', 'slug'],
  components: {
    VueFinalModal,
    ArgonButton,
  },
  data() {
    return {
      showModal: this.modalShow,
      successModal: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      successStatus: false,
      unsubscribeStatus: '',
      unsubscribeMsg: ''
    }
  },
  methods: {
    modalClose() {
      this.emitter.emit('subscribe-modal-close-event', {'eventContent': false});
    },
    cancelPurchaseBundle() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/unsubscribe-telnor', {slug: this.slug}, this.config)
          .then(response => {
            this.loaderActive = false;
            this.successModal = true;
            let data = response.data;
            this.successStatus = data.success;
            this.unsubscribeStatus = data.success ? this.$t('SUCCESS') : this.$t('ERROR');
            this.unsubscribeMsg = data.msg;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;

  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  margin-right: 10%;
  margin-left: 10%;

}

@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
